module.exports = __webpack_public_path__ + "img/index-banner.2091adc7.png";